/*
 * Houses all locale-specific settings for assortments. Eventually this will move to live in the backend powered
 * by a service
 */

// EXPERIMENT_MARKER=LOW_ATV_UI
// Note that packagesList data under both the grid section
// and the SIGNUP_PAGE section seem like they are not being used
// We will clean this up after the experiment

import lazyGettext from 'js-utils/lazy-gettext';
import {
    AR_LOCALE,
    AT_LOCALE,
    AU_LOCALE,
    BE_LOCALE,
    BR_LOCALE,
    CA_LOCALE,
    CL_LOCALE,
    CO_LOCALE,
    DE_CH_LOCALE,
    DE_LOCALE,
    DK_LOCALE,
    ES_LOCALE,
    FI_LOCALE,
    FR_BE_LOCALE,
    FR_CA_LOCALE,
    FR_CH_LOCALE,
    FR_LOCALE,
    GB_LOCALE,
    HK_LOCALE,
    IE_LOCALE,
    IT_LOCALE,
    MX_LOCALE,
    NL_LOCALE,
    NO_LOCALE,
    NZ_LOCALE,
    PE_LOCALE,
    PT_LOCALE,
    SE_LOCALE,
    SG_LOCALE,
    US_LOCALE,
} from 'js-utils/intl';
import * as features from './features';
import * as featuresComparison from './featuresComparison';
import {
    FINE_PRINT_WITH_FIXED_FEE,
    FINE_PRINT_WITH_FIXED_FEE_NZ,
    OVERVIEW_PAGE,
    PACKAGE_COMPARISON_PAGE,
    PACKAGE_ONE,
    PACKAGE_ONE_PAGE,
    PACKAGE_SELECTION_PAGE,
    PACKAGE_THREE,
    PACKAGE_THREE_PAGE,
    PACKAGE_TWO,
    PACKAGE_TWO_PAGE,
    PER_PAID_TICKET_WITHOUT_FINE_PRINT,
    PRICE_PER_PAID_TICKET,
    PRICING_PAGE,
    SIGNUP_PAGE,
} from './main';
import {
    ESSENTIALS_DESCRIPTION,
    FREE_ALWAYS_FREE_FEATURE,
    ONSITE_PLANNING,
    ORGANIZER_APP_FEATURE,
    PASS_FEES_ON_SECONDARY_HEADER,
    PREMIUM_DESCRIPTION,
    PRICE_DESCRIPTION,
    PROFESSIONAL_DESCRIPTION,
    RULE_DAYOF,
    STAFFING_FEATURE,
    UK_PROFESSIONAL_DESCRIPTION,
} from './overview';
import { appendFinePrintSignifier } from '../containers/utils';
import * as signupFeatures from './signupFeatures';
import * as testimonials from './testimonials';
import {
    CHANGE_PACKAGE,
    CHANGE_PACKAGE_AU,
    FREE_OPTION_AU,
    FREE_OPTION_NEW_TLDS,
    PACKAGE_DIFFER,
    PACKAGE_DIFFER_AU,
    PAY_FEES,
    PAY_FEES_AU,
    PAY_FEES_NEW_TLDS,
    PAYMENT_OPTIONS,
    PAYMENT_OPTIONS_AU,
    PAYMENT_OPTIONS_NEW_TLDS,
    PRIVATE_EVENT,
    PRIVATE_EVENT_AU,
    TICKET_TYPE,
    TICKET_TYPE_AU,
    TICKETING_ESSENTIALS,
    TICKETING_ESSENTIALS_AU,
} from './faqs';

export default {
    [AR_LOCALE]: {
        [OVERVIEW_PAGE]: {
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [],
            },
            testimonials: {
                testimonials: [
                    testimonials.FUNDACION_ELEGI_SONREIR,
                    testimonials.CONVENCIONES_WALKERS,
                    testimonials.DROVET,
                    testimonials.ASISTEM_RRHH,
                    testimonials.FUNDACION_MEDIAR,
                ],
            },
        },
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.INSTALLMENT_PAYMENTS_LATAM,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        featuresComparison.ON_DEMAND_PAYOUTS,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: ' + IVA',
            },
            testimonials: {
                testimonials: [
                    testimonials.CENTRO_COMERICAL,
                    testimonials.HERNAN_CASCIARI,
                    testimonials.SB_CONGRESOS,
                ],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: ' + IVA',
            },
            testimonials: {
                testimonials: [
                    testimonials.PAYONEER,
                    testimonials.TMX,
                    testimonials.OPEN_SHIMANO,
                ],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.INSTALLMENT_PAYMENTS,
                    features.TEAM_PERMISSIONS_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
            testimonials: {
                testimonials: [
                    testimonials.THE_YOGA_EXPO,
                    testimonials.MAKER_FAIRE,
                    testimonials.NATIONAL_SAWDUST,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        logoImg: 'pricing/spanish--logo-basico',
                    },
                    [PACKAGE_TWO]: {
                        logoImg: 'pricing/spanish--logo-profesional',
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.RENTAL_EQUIPMENT,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: ' + IVA',
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        logoImg: 'pricing/spanish--logo-basico',
                    },
                    [PACKAGE_TWO]: {
                        logoImg: 'pricing/spanish--logo-profesional',
                        features: features.PACKAGE_TWO_FEATURES,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.RENTAL_EQUIPMENT,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: ' + IVA',
                finePrint: '',
            },
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_THREE]: {
                            features:
                                signupFeatures.PACKAGE_THREE_FEATURES_A_AR_BR,
                        },
                    },
                },
                extraMainFeatures: [
                    signupFeatures.CUSTOMER_SUPPORT,
                    signupFeatures.TICKET_TYPES,
                    signupFeatures.TR_ESSENTIALS,
                    signupFeatures.LISTING_PARTNER_SITES,
                    signupFeatures.TICKET_SALES_SITE,
                    signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                    signupFeatures.DETAIL_SALES_ANALYTICS,
                    signupFeatures.ONSITE_RENTAL_SUPPORT,
                    featuresComparison.PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: signupFeatures.PACKAGE_THREE_FEATURES_A_AR_BR,
                    },
                },
            },
            extraMainFeatures: [
                signupFeatures.CUSTOMER_SUPPORT,
                signupFeatures.TICKET_TYPES,
                signupFeatures.TR_ESSENTIALS,
                signupFeatures.LISTING_PARTNER_SITES,
                signupFeatures.TICKET_SALES_SITE,
                signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                signupFeatures.DETAIL_SALES_ANALYTICS,
                signupFeatures.ONSITE_RENTAL_SUPPORT,
                featuresComparison.PRODUCT_TRAINING,
            ],
        },
    },
    [AT_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.TICKETS_ON_FACEBOOK,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                        featuresComparison.BUSINESS_HOUR_PHONE_SUPPORT,
                    ],
                },
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                secondaryHeading: PASS_FEES_ON_SECONDARY_HEADER,
                packages: {
                    [PACKAGE_ONE]: {
                        description: ESSENTIALS_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: features.PACKAGE_ONE_GERMAN_FEATURES,
                    },
                    [PACKAGE_TWO]: {
                        description: PROFESSIONAL_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: features.PACKAGE_TWO_GERMAN_FEATURES,
                    },
                    [PACKAGE_THREE]: {
                        description: PREMIUM_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: features.PACKAGE_THREE_GERMAN_FEATURES,
                    },
                },
            },
        },
    },
    [AU_LOCALE]: {
        [OVERVIEW_PAGE]: {
            testimonials: {
                testimonials: [
                    testimonials.RHYTHM_AND_VINES,
                    testimonials.BOTTLE_SHOP_CONCEPTS,
                    testimonials.THICK_AS_THIEVES,
                    testimonials.BEYOND_THE_VALLEY,
                    testimonials.LOVES_DATA_CONFERENCE,
                ],
            },
        },
        [PACKAGE_COMPARISON_PAGE]: {
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITH_LANDING_PAGES,
                },
                1: {
                    features:
                        featuresComparison.PROMOTE_AND_GROW_WITH_LANDING_PAGES,
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
                features: [
                    features.BASIC_TICKETING,
                    features.REPORTING_ESSENTIALS,
                    features.PARTNER_SITES,
                    features.UNLIMITED_TICKET_TYPES,
                    features.ORGANIZER_MOBILE_APP,
                    features.ONLINE_HELP_CENTER,
                ],
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [
                    testimonials.YMCA,
                    testimonials.TED_X_MELBOURNE,
                    testimonials.BEER_INCIDER,
                ],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [
                    testimonials.THICK_AS_THIEVES,
                    testimonials.AWESOME_INC_U,
                    testimonials.ARC_FOR_UNSW,
                ],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.RENT_EQUIPMENT,
                    features.PHONE_24_7_SUPPORT,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
            testimonials: {
                testimonials: [
                    testimonials.RHYTHM_AND_VINES,
                    testimonials.BOTTLE_SHOP_CONCEPTS,
                    testimonials.YAH_YAHS,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.RENTAL_EQUIPMENT,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.PHONE_SUPPORT,
                        ],
                    },
                },
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE_AU,
                    TICKET_TYPE_AU,
                    FREE_OPTION_AU,
                    TICKETING_ESSENTIALS_AU,
                    PACKAGE_DIFFER_AU,
                    PRIVATE_EVENT_AU,
                    PAY_FEES_AU,
                    PAYMENT_OPTIONS_AU,
                ],
            },
            grid: {
                extraMainFeatures: [signupFeatures.CUSTOMER_SUPPORT_WITH_PHONE],
            },
        },
    },
    [BE_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.TICKETS_ON_FACEBOOK,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_CONSULTATION_LANDING_PAGE,
                        featuresComparison.RENTAL_EQUIPMENT_LANDING_PAGE,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                        featuresComparison.BUSINESS_HOUR_PHONE_SUPPORT,
                    ],
                },
            },
        },
    },
    [BR_LOCALE]: {
        [OVERVIEW_PAGE]: {
            testimonials: {
                testimonials: [
                    testimonials.CONAACUP,
                    testimonials.FORRO_DA_LUA_CHEIA,
                    testimonials.SENSEDIA,
                    testimonials.TRIANONS,
                    testimonials.COMUNIDADE_DAS_NACOES,
                ],
            },
        },
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.INDUSTRY_LEADING_SEARCH,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.INSTALLMENT_PAYMENTS_LATAM,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP_BR,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS_BR,
                        featuresComparison.ON_SITE_CONSULTATION,
                        featuresComparison.RENTAL_EQUIPMENT,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS_BR,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS_BR,
                        featuresComparison.ON_SITE_APP_INTEGRATIONS_BR,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        featuresComparison.ON_DEMAND_PAYOUTS,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [
                    testimonials.CASA_COMIGO,
                    testimonials.NEW_ME,
                    testimonials.ZUM_BRAZIL_EVENTOS,
                ],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [
                    testimonials.ABRADI_SP,
                    testimonials.SOCIAL_MEDIA_WEEK_SP,
                    testimonials.SUPERLOGICA,
                ],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.RENT_EQUIPMENT,
                    features.INSTALLMENT_PAYMENTS,
                    features.TEAM_PERMISSIONS_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
            testimonials: {
                testimonials: [
                    testimonials.GFNY,
                    testimonials.PLUS_NETWORK,
                    testimonials.QUEREMOS,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.RENTAL_EQUIPMENT,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.RENTAL_EQUIPMENT,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_THREE]: {
                            features:
                                signupFeatures.PACKAGE_THREE_FEATURES_A_AR_BR,
                        },
                    },
                },
                extraMainFeatures: [
                    signupFeatures.CUSTOMER_SUPPORT,
                    signupFeatures.TICKET_TYPES,
                    signupFeatures.TR_ESSENTIALS,
                    signupFeatures.LISTING_PARTNER_SITES,
                    signupFeatures.TICKET_SALES_SITE,
                    signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                    signupFeatures.DETAIL_SALES_ANALYTICS,
                    signupFeatures.ONSITE_RENTAL_SUPPORT,
                    featuresComparison.PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: signupFeatures.PACKAGE_THREE_FEATURES_A_AR_BR,
                    },
                },
            },
            extraMainFeatures: [
                signupFeatures.CUSTOMER_SUPPORT,
                signupFeatures.TICKET_TYPES,
                signupFeatures.TR_ESSENTIALS,
                signupFeatures.LISTING_PARTNER_SITES,
                signupFeatures.TICKET_SALES_SITE,
                signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                signupFeatures.DETAIL_SALES_ANALYTICS,
                signupFeatures.ONSITE_RENTAL_SUPPORT,
                featuresComparison.PRODUCT_TRAINING,
            ],
        },
    },
    [CA_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITH_LANDING_PAGES,
                },
                1: {
                    features:
                        featuresComparison.PROMOTE_AND_GROW_WITH_LANDING_PAGES,
                },
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.RENT_EQUIPMENT,
                    features.PHONE_24_7_SUPPORT,
                    features.INSTALLMENT_PAYMENTS,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        priceDescription: lazyGettext(
                            'Minimum threshold applies',
                        ),
                    },
                },
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        priceDescription: lazyGettext(
                            'Minimum threshold applies',
                        ),
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.RENTAL_EQUIPMENT,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.PHONE_SUPPORT,
                        ],
                    },
                },
            },
            grid: {
                showFinePrint: true,
                finePrint: FINE_PRINT_WITH_FIXED_FEE,
                pricePerPaidTicket: appendFinePrintSignifier(
                    PRICE_PER_PAID_TICKET,
                ),
                extraMainFeatures: [signupFeatures.CUSTOMER_SUPPORT_WITH_PHONE],
            },
        },
    },
    [DE_LOCALE]: {
        [OVERVIEW_PAGE]: {
            testimonials: {
                testimonials: [
                    testimonials.BITS_AND_PRETZELS,
                    testimonials.TECH_OPEN_AIR,
                    testimonials.INTERATIONAL_GAMES_WEEK,
                    testimonials.CHESS_BOXING,
                    testimonials.XLETIX,
                ],
            },
        },
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.TICKETS_ON_FACEBOOK,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                        featuresComparison.BUSINESS_HOUR_PHONE_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [
                    testimonials.CHESS_BOXING,
                    testimonials.CRESCENT_CITY_CLASSIC,
                    testimonials.WEB_DIRECTIONS,
                ],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            featureListTwo: {
                heading: lazyGettext(
                    'Simplify operations to scale your business',
                ),
                features: [
                    features.CUSTOM_REGISTRATION,
                    features.INTEGRATIONS_B,
                ],
                imagePath: `${PACKAGE_TWO}/simplify`,
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
            testimonials: {
                testimonials: [
                    testimonials.TECH_OPEN_AIR_DETAIL,
                    testimonials.DANCE_411,
                    testimonials.AWESOME_INC_U,
                ],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            testimonials: {
                testimonials: [
                    testimonials.XLETIX,
                    testimonials.INTERATIONAL_GAMES_WEEK,
                    testimonials.BITS_AND_PRETZELS_DETAIL,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
                secondaryHeading: PASS_FEES_ON_SECONDARY_HEADER,
                packages: {
                    [PACKAGE_ONE]: {
                        description: ESSENTIALS_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: features.PACKAGE_ONE_GERMAN_FEATURES,
                    },
                    [PACKAGE_TWO]: {
                        description: PROFESSIONAL_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: features.PACKAGE_TWO_GERMAN_FEATURES,
                    },
                    [PACKAGE_THREE]: {
                        description: PREMIUM_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: features.PACKAGE_THREE_GERMAN_FEATURES,
                    },
                },
            },
        },
    },
    [DK_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features: featuresComparison.START_SELLING_NORDICS,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.INDUSTRY_LEADING_SEARCH,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                    ],
                },
                2: {
                    features: [
                        featuresComparison.SALES_RSVP_DASHBOARD,
                        featuresComparison.DETAILED_EXPORTS,
                        featuresComparison.MOBILE_ORGANIZER_APP,
                        featuresComparison.GOOGLE_ANALYTICS_INTEGRATION,
                        featuresComparison.SURVEY_INTEGRATIONS,
                        featuresComparison.SELF_SERVICE_TRACKING_PIXELS,
                        featuresComparison.CROSS_EVENT_ANALYTICS,
                        featuresComparison.ANALYTICS_BY_TICKET_TYPE,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        // featuresComparison.EARLY_PAYOUTS_FR_BE, TEMP REMOVING THIS FOR COVID-19
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS_WITH_EPP,
                    features.DETAILED_ANALYTICS_C,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                    // features.PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: features.PACKAGE_ONE_FEATURES,
                    },
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES_FOR_DK_NO_SE,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES_NEW_TLDS,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [ES_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_CONSULTATION,
                        featuresComparison.RENTAL_EQUIPMENT,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                        featuresComparison.RFID_ACCESS_MANAGEMENT_LANDING_PAGE,
                        featuresComparison.CASHLESS_PAYMENTS_LANDING_PAGE,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            grid: {
                extraMainFeatures: [signupFeatures.CUSTOMER_SUPPORT],
            },
        },
    },
    [FI_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features: featuresComparison.START_SELLING_NORDICS,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.INDUSTRY_LEADING_SEARCH,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                2: {
                    features: [
                        featuresComparison.SALES_RSVP_DASHBOARD,
                        featuresComparison.DETAILED_EXPORTS,
                        featuresComparison.MOBILE_ORGANIZER_APP,
                        featuresComparison.GOOGLE_ANALYTICS_INTEGRATION,
                        featuresComparison.SURVEY_INTEGRATIONS,
                        featuresComparison.SELF_SERVICE_TRACKING_PIXELS,
                        featuresComparison.CROSS_EVENT_ANALYTICS,
                        featuresComparison.ANALYTICS_BY_TICKET_TYPE,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_APP_INTEGRATIONS,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        // featuresComparison.EARLY_PAYOUTS_FR_BE,TEMP REMOVING THIS FOR COVID-19
                        // featuresComparison.CUSTOM_PAYOUT_SCHEDULE, Temp removed for COVID-19
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS_WITH_EPP,
                    features.DETAILED_ANALYTICS_C,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                    // features.PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: features.PACKAGE_ONE_FEATURES_UK,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS,
                ],
            },
        },
    },
    [FR_BE_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_FR_BE,
            sections: {
                0: {
                    features: [
                        featuresComparison.TICKET_TYPES_FR_BE,
                        featuresComparison.PUBLIC_EVENTS,
                        featuresComparison.PRIVATE_EVENTS,
                        featuresComparison.UNLIMITED_EVENTS,
                        featuresComparison.STANDARD_CHECKOUT_FORM,
                        featuresComparison.DIGITAL_TICKETS,
                        featuresComparison.MOBILE_TICKETS,
                        featuresComparison.DONATION_COLLECTION,
                        featuresComparison.PASS_ON_FEES,
                        featuresComparison.RECURRING_EVENTS,
                        featuresComparison.CUSTOM_URL,
                        featuresComparison.WAITLISTS,
                        featuresComparison.AT_THE_DOOR_SALES,
                        featuresComparison.CUSTOMIZABLE_ATTENDEE_INFO,
                        featuresComparison.CUSTOMIZABLE_ORDER_CONFIRMATION,
                        featuresComparison.RESERVED_SEATING_FR_BE,
                        featuresComparison.REGISTRATION_TRANSFERS,
                        featuresComparison.GROUP_REGISTRATION,
                        featuresComparison.PRODUCT_TRAINING,
                    ],
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.TICKETS_ON_FACEBOOK,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_CONSULTATION_LANDING_PAGE,
                        featuresComparison.ON_SITE_STAFFING_LANDING_PAGE,
                        featuresComparison.RENTAL_EQUIPMENT_LANDING_PAGE,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                        featuresComparison.RFID_ACCESS_MANAGEMENT_LANDING_PAGE,
                        featuresComparison.CASHLESS_PAYMENTS_LANDING_PAGE,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        // featuresComparison.EARLY_PAYOUTS_FR_BE,TEMP REMOVING THIS FOR COVID-19
                        // featuresComparison.CUSTOM_PAYOUT_SCHEDULE,  Temp removed for COVID-19
                    ],
                },
            },
        },
    },
    [FR_CA_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features: [
                        featuresComparison.TICKET_TYPES_FR_CA,
                        featuresComparison.PUBLIC_EVENTS,
                        featuresComparison.PRIVATE_EVENTS,
                        featuresComparison.UNLIMITED_EVENTS,
                        featuresComparison.STANDARD_CHECKOUT_FORM,
                        featuresComparison.DIGITAL_TICKETS,
                        featuresComparison.MOBILE_TICKETS,
                        featuresComparison.DONATION_COLLECTION,
                        featuresComparison.PASS_ON_FEES,
                        featuresComparison.FUNDRAISING_INTEGRATIONS,
                        featuresComparison.RECURRING_EVENTS,
                        featuresComparison.CUSTOM_URL,
                        featuresComparison.WAITLISTS,
                        featuresComparison.AT_THE_DOOR_SALES,
                        featuresComparison.CUSTOMIZABLE_ATTENDEE_INFO,
                        featuresComparison.CUSTOMIZABLE_ORDER_CONFIRMATION,
                        featuresComparison.RESERVED_SEATING_LANDING_PAGE,
                        featuresComparison.REGISTRATION_TRANSFERS,
                        featuresComparison.GROUP_REGISTRATION,
                        featuresComparison.PRODUCT_TRAINING,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        // featuresComparison.EARLY_PAYOUTS_FR_CA,TEMP REMOVING THIS FOR COVID-19
                        // featuresComparison.CUSTOM_PAYOUT_SCHEDULE,  Temp removed for COVID-19
                    ],
                },
            },
        },
    },
    [FR_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_APP_INTEGRATIONS,
                        featuresComparison.ON_SITE_CONSULTATION,
                        featuresComparison.RENTAL_EQUIPMENT,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                        featuresComparison.RFID_ACCESS_MANAGEMENT_LANDING_PAGE,
                        featuresComparison.CASHLESS_PAYMENTS_LANDING_PAGE,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
    },
    [GB_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITH_LANDING_PAGES,
                },
                1: {
                    features:
                        featuresComparison.PROMOTE_AND_GROW_WITH_LANDING_PAGES,
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS_WITH_EPP,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                    // features.PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.RENT_EQUIPMENT,
                    features.PHONE_24_7_SUPPORT,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                secondaryHeading: PASS_FEES_ON_SECONDARY_HEADER,
                packages: {
                    [PACKAGE_ONE]: {
                        description: ESSENTIALS_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: features.PACKAGE_ONE_FEATURES_UK,
                    },
                    [PACKAGE_TWO]: {
                        description: UK_PROFESSIONAL_DESCRIPTION,
                        priceDescription: PRICE_DESCRIPTION,
                        features: features.PACKAGE_TWO_FEATURES_UK,
                    },
                    [PACKAGE_THREE]: {
                        description: PREMIUM_DESCRIPTION,
                        features: features.PACKAGE_THREE_FEATURES_UK,
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            grid: {
                extraMainFeatures: [signupFeatures.CUSTOMER_SUPPORT_WITH_PHONE],
            },
        },
    },
    [DE_CH_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITH_LANDING_PAGES,
                },
                1: {
                    features:
                        featuresComparison.PROMOTE_AND_GROW_WITH_LANDING_PAGES_CH,
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        // signupFeatures.PAYOUTS_BEFORE_EVENT,TEMP REMOVING THIS FOR COVID-19
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                        featuresComparison.PHONE_SUPPORT_CH,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS_WITH_EPP,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                    // features.PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: features.PACKAGE_ONE_FEATURES,
                    },
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES_CH,
                    },
                    [PACKAGE_THREE]: {
                        features: features.PACKAGE_THREE_FEATURES_CH,
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    TICKET_TYPE,
                    FREE_OPTION_NEW_TLDS,
                    TICKETING_ESSENTIALS,
                    PACKAGE_DIFFER,
                    PRIVATE_EVENT,
                    PAY_FEES_NEW_TLDS,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [FR_CH_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITH_LANDING_PAGES,
                },
                1: {
                    features:
                        featuresComparison.PROMOTE_AND_GROW_WITH_LANDING_PAGES_CH,
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        // signupFeatures.PAYOUTS_BEFORE_EVENT,TEMP REMOVING THIS FOR COVID-19
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                        featuresComparison.CHAT_SUPPORT_FR_CH,
                        featuresComparison.PHONE_SUPPORT_CH,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS_WITH_EPP,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                    // features.PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: features.PACKAGE_ONE_FEATURES,
                    },
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES_CH,
                    },
                    [PACKAGE_THREE]: {
                        features: features.PACKAGE_THREE_FEATURES_CH,
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    TICKET_TYPE,
                    FREE_OPTION_NEW_TLDS,
                    TICKETING_ESSENTIALS,
                    PACKAGE_DIFFER,
                    PRIVATE_EVENT,
                    PAY_FEES_NEW_TLDS,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [HK_LOCALE]: {
        [OVERVIEW_PAGE]: {
            featureListOne: {
                features: [FREE_ALWAYS_FREE_FEATURE, ORGANIZER_APP_FEATURE],
            },
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [],
            },
        },
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                        // featuresComparison.CUSTOM_PAYOUT_SCHEDULE,  Temp removed for COVID-19
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                        featuresComparison.BUSINESS_HOUR_CHAT_SUPPORT_NZ_HK_SG,
                        featuresComparison.BUSINESS_HOUR_PHONE_SUPPORT_NZ_HK_SG,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_THREE]: {
                            features:
                                signupFeatures.PACKAGE_THREE_FEATURES_A_HK_SG,
                        },
                    },
                },
                extraMainFeatures: [
                    signupFeatures.CUSTOMER_SUPPORT,
                    signupFeatures.TICKET_TYPES,
                    signupFeatures.TR_ESSENTIALS,
                    signupFeatures.LISTING_PARTNER_SITES,
                    signupFeatures.TICKET_SALES_SITE,
                    signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                    signupFeatures.DETAIL_SALES_ANALYTICS,
                    featuresComparison.PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: signupFeatures.PACKAGE_THREE_FEATURES_A_HK_SG,
                    },
                },
            },
            extraMainFeatures: [
                signupFeatures.CUSTOMER_SUPPORT,
                signupFeatures.TICKET_TYPES,
                signupFeatures.TR_ESSENTIALS,
                signupFeatures.LISTING_PARTNER_SITES,
                signupFeatures.TICKET_SALES_SITE,
                signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                signupFeatures.DETAIL_SALES_ANALYTICS,
                featuresComparison.PRODUCT_TRAINING,
            ],
        },
    },
    [CL_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features: featuresComparison.START_SELLING_CL_CO_PE,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.INSTALLMENT_PAYMENTS,
                    features.TEAM_PERMISSIONS_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES_FOR_CL_CO_PE,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.BRAND_PAGES,
                            features.INSTALLMENT,
                            features.PRODUCT_TRAINING,
                        ],
                        priceDescription: lazyGettext(
                            'Minimum threshold applies',
                        ),
                    },
                },
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [CO_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features: featuresComparison.START_SELLING_CL_CO_PE,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.INSTALLMENT_PAYMENTS,
                    features.TEAM_PERMISSIONS_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES_FOR_CL_CO_PE,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.BRAND_PAGES,
                            features.INSTALLMENT,
                            features.PRODUCT_TRAINING,
                        ],
                        priceDescription: lazyGettext(
                            'Minimum threshold applies',
                        ),
                    },
                },
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [IE_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS_WITH_EPP,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                    // features.PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.RENT_EQUIPMENT,
                    features.PHONE_24_7_SUPPORT,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: features.PACKAGE_ONE_FEATURES_UK,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.RENTAL_EQUIPMENT,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.PHONE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            grid: {
                extraMainFeatures: [signupFeatures.CUSTOMER_SUPPORT_WITH_PHONE],
            },
        },
    },
    [IT_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_CONSULTATION,
                        featuresComparison.RENTAL_EQUIPMENT,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                        featuresComparison.RFID_ACCESS_MANAGEMENT_LANDING_PAGE,
                        featuresComparison.CASHLESS_PAYMENTS_LANDING_PAGE,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
    },
    [MX_LOCALE]: {
        [OVERVIEW_PAGE]: {
            featureListOne: {
                features: [FREE_ALWAYS_FREE_FEATURE, ORGANIZER_APP_FEATURE],
            },
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [],
            },
        },
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.INSTALLMENT_PAYMENTS_LATAM,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.INSTALLMENT_PAYMENTS,
                    features.TEAM_PERMISSIONS_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.BRAND_PAGES,
                            features.INSTALLMENT,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                        priceDescription: lazyGettext(
                            'Minimum threshold applies',
                        ),
                    },
                },
            },
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_TWO]: {
                            features: signupFeatures.PACKAGE_TWO_FEATURES_A_MX,
                        },
                        [PACKAGE_THREE]: {
                            features:
                                signupFeatures.PACKAGE_THREE_FEATURES_A_MX,
                        },
                    },
                },
                extraMainFeatures: [
                    signupFeatures.CUSTOMER_SUPPORT,
                    signupFeatures.TICKET_TYPES,
                    signupFeatures.TR_ESSENTIALS,
                    signupFeatures.LISTING_PARTNER_SITES,
                    signupFeatures.TICKET_SALES_SITE,
                    signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                    signupFeatures.DETAIL_SALES_ANALYTICS,
                    featuresComparison.PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: signupFeatures.PACKAGE_TWO_FEATURES_A_MX,
                    },
                    [PACKAGE_THREE]: {
                        features: signupFeatures.PACKAGE_THREE_FEATURES_A_MX,
                    },
                },
            },
            extraMainFeatures: [
                signupFeatures.CUSTOMER_SUPPORT,
                signupFeatures.TICKET_TYPES,
                signupFeatures.TR_ESSENTIALS,
                signupFeatures.LISTING_PARTNER_SITES,
                signupFeatures.TICKET_SALES_SITE,
                signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                signupFeatures.DETAIL_SALES_ANALYTICS,
                featuresComparison.PRODUCT_TRAINING,
            ],
        },
    },
    [NL_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.TICKETS_ON_FACEBOOK,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_CONSULTATION_LANDING_PAGE,
                        featuresComparison.ON_SITE_STAFFING_LANDING_PAGE,
                        featuresComparison.RENTAL_EQUIPMENT_LANDING_PAGE,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                        featuresComparison.RFID_ACCESS_MANAGEMENT_LANDING_PAGE,
                        featuresComparison.CASHLESS_PAYMENTS_LANDING_PAGE,
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                        featuresComparison.BUSINESS_HOUR_PHONE_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
    },
    [NO_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features: featuresComparison.START_SELLING_NORDICS,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.INDUSTRY_LEADING_SEARCH,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                    ],
                },
                2: {
                    features: [
                        featuresComparison.SALES_RSVP_DASHBOARD,
                        featuresComparison.DETAILED_EXPORTS,
                        featuresComparison.MOBILE_ORGANIZER_APP,
                        featuresComparison.GOOGLE_ANALYTICS_INTEGRATION,
                        featuresComparison.SURVEY_INTEGRATIONS,
                        featuresComparison.SELF_SERVICE_TRACKING_PIXELS,
                        featuresComparison.CROSS_EVENT_ANALYTICS,
                        featuresComparison.ANALYTICS_BY_TICKET_TYPE,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        // featuresComparison.EARLY_PAYOUTS_FR_BE,TEMP REMOVING THIS FOR COVID-19
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS_WITH_EPP,
                    features.DETAILED_ANALYTICS_C,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                    // features.PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: features.PACKAGE_ONE_FEATURES,
                    },
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES_FOR_DK_NO_SE,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES_NEW_TLDS,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [NZ_LOCALE]: {
        [OVERVIEW_PAGE]: {
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [STAFFING_FEATURE],
            },
            testimonials: {
                testimonials: [
                    testimonials.RHYTHM_AND_VINES,
                    testimonials.BOTTLE_SHOP_CONCEPTS,
                    testimonials.THICK_AS_THIEVES,
                    testimonials.BEYOND_THE_VALLEY,
                    testimonials.LOVES_DATA_CONFERENCE,
                ],
            },
        },
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.INDUSTRY_LEADING_SEARCH,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.TICKETS_ON_FACEBOOK,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_APP_INTEGRATIONS,
                        featuresComparison.ON_SITE_CONSULTATION_LANDING_PAGE,
                        featuresComparison.ON_SITE_STAFFING_LANDING_PAGE,
                        featuresComparison.RENTAL_EQUIPMENT_LANDING_PAGE,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                        featuresComparison.BUSINESS_HOUR_CHAT_SUPPORT_NZ_HK_SG,
                        featuresComparison.BUSINESS_HOUR_PHONE_SUPPORT_NZ_HK_SG,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: FINE_PRINT_WITH_FIXED_FEE_NZ,
            },
            testimonials: {
                testimonials: [
                    testimonials.YMCA,
                    testimonials.TED_X_MELBOURNE,
                    testimonials.BEER_INCIDER,
                ],
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                ],
                processingFeesFinePrint: FINE_PRINT_WITH_FIXED_FEE_NZ,
            },
            testimonials: {
                testimonials: [
                    testimonials.THICK_AS_THIEVES,
                    testimonials.AWESOME_INC_U,
                    testimonials.ARC_FOR_UNSW,
                ],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.RENT_EQUIPMENT,
                    features.PHONE_24_7_SUPPORT,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
            testimonials: {
                testimonials: [
                    testimonials.RHYTHM_AND_VINES,
                    testimonials.BOTTLE_SHOP_CONCEPTS,
                    testimonials.YAH_YAHS,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.RENTAL_EQUIPMENT,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                finePrint: FINE_PRINT_WITH_FIXED_FEE_NZ,
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.RENTAL_EQUIPMENT,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.PHONE_SUPPORT,
                        ],
                    },
                },
                finePrint: FINE_PRINT_WITH_FIXED_FEE_NZ,
            },
            grid: {
                extraMainFeatures: [signupFeatures.CUSTOMER_SUPPORT_WITH_PHONE],
            },
        },
    },
    [PE_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features: featuresComparison.START_SELLING_CL_CO_PE,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.INSTALLMENT_PAYMENTS,
                    features.TEAM_PERMISSIONS_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES_FOR_CL_CO_PE,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.BRAND_PAGES,
                            features.INSTALLMENT,
                            features.PRODUCT_TRAINING,
                        ],
                        priceDescription: lazyGettext(
                            'Minimum threshold applies',
                        ),
                    },
                },
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [PT_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITHOUT_FUNDRAISING,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                        featuresComparison.RFID_ENABLED,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_CONSULTATION,
                        featuresComparison.RENTAL_EQUIPMENT,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
        },
    },
    [SE_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features: featuresComparison.START_SELLING_NORDICS,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.INDUSTRY_LEADING_SEARCH,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                    ],
                },
                2: {
                    features: [
                        featuresComparison.SALES_RSVP_DASHBOARD,
                        featuresComparison.DETAILED_EXPORTS,
                        featuresComparison.MOBILE_ORGANIZER_APP,
                        featuresComparison.GOOGLE_ANALYTICS_INTEGRATION,
                        featuresComparison.SURVEY_INTEGRATIONS,
                        featuresComparison.SELF_SERVICE_TRACKING_PIXELS,
                        featuresComparison.CROSS_EVENT_ANALYTICS,
                        featuresComparison.ANALYTICS_BY_TICKET_TYPE,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.SECURE_PAYMENT_PROCESSING,
                        // featuresComparison.EARLY_PAYOUTS_FR_BE,TEMP REMOVING THIS FOR COVID-19
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                    ],
                },
            },
        },
        [PACKAGE_ONE_PAGE]: {
            featuresExpansion: {
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS_WITH_EPP,
                    features.DETAILED_ANALYTICS_C,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                    // features.PAYOUTS_B,TEMP REMOVING THIS FOR COVID-19
                ],
                processingFeesFinePrint: '',
            },
            mainHeader: {
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_ONE]: {
                        features: features.PACKAGE_ONE_FEATURES,
                    },
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES_FOR_DK_NO_SE,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
                perPaidTicketText: PER_PAID_TICKET_WITHOUT_FINE_PRINT,
                finePrint: '',
            },
            faqs: {
                faqs: [
                    CHANGE_PACKAGE,
                    FREE_OPTION_NEW_TLDS,
                    PACKAGE_DIFFER,
                    PAY_FEES_NEW_TLDS,
                    TICKET_TYPE,
                    TICKETING_ESSENTIALS,
                    PRIVATE_EVENT,
                    PAYMENT_OPTIONS_NEW_TLDS,
                ],
            },
        },
    },
    [SG_LOCALE]: {
        [OVERVIEW_PAGE]: {
            featureListOne: {
                features: [FREE_ALWAYS_FREE_FEATURE, ORGANIZER_APP_FEATURE],
            },
            onsiteFeatures: {
                heading: RULE_DAYOF,
                secondaryHeading: ONSITE_PLANNING,
                features: [],
            },
        },
        [PACKAGE_COMPARISON_PAGE]: {
            sections: {
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.COMMUNITY_PAGES,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_APP_INTEGRATIONS,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                    ],
                },
                4: {
                    features: [
                        featuresComparison.ALL_MAJOR_CREDIT_CARDS,
                        featuresComparison.PCI_COMPLIANT,
                        featuresComparison.DIRECT_DEPOSIT_OR_CHECK,
                        // featuresComparison.CUSTOM_PAYOUT_SCHEDULE, Temp removed for COVID-19
                    ],
                },
                5: {
                    features: [
                        featuresComparison.ONLINE_HELP_CENTER,
                        featuresComparison.EMAIL_SUPPORT,
                        featuresComparison.BUSINESS_HOUR_CHAT_SUPPORT_NZ_HK_SG,
                        featuresComparison.BUSINESS_HOUR_PHONE_SUPPORT_NZ_HK_SG,
                    ],
                },
            },
        },
        [PACKAGE_TWO_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_ESSENTIALS,
                    features.CHECKOUT_WIDGET_B,
                    features.DETAILED_ANALYTICS_C,
                    features.RESERVED_SEATING,
                    features.UNLIMITED_TICKET_TYPES,
                    features.CUSTOM_REGISTRATION,
                ],
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.BRAND_PAGES,
                            features.PRODUCT_TRAINING,
                            features.ONLINE_SUPPORT,
                        ],
                    },
                },
            },
            grid: {
                packagesList: {
                    packages: {
                        [PACKAGE_THREE]: {
                            features:
                                signupFeatures.PACKAGE_THREE_FEATURES_A_HK_SG,
                        },
                    },
                },
                extraMainFeatures: [
                    signupFeatures.CUSTOMER_SUPPORT,
                    signupFeatures.TICKET_TYPES,
                    signupFeatures.TR_ESSENTIALS,
                    signupFeatures.LISTING_PARTNER_SITES,
                    signupFeatures.TICKET_SALES_SITE,
                    signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                    signupFeatures.DETAIL_SALES_ANALYTICS,
                    featuresComparison.PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: signupFeatures.PACKAGE_THREE_FEATURES_A_HK_SG,
                    },
                },
            },
            extraMainFeatures: [
                signupFeatures.CUSTOMER_SUPPORT,
                signupFeatures.TICKET_TYPES,
                signupFeatures.TR_ESSENTIALS,
                signupFeatures.LISTING_PARTNER_SITES,
                signupFeatures.TICKET_SALES_SITE,
                signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                signupFeatures.DETAIL_SALES_ANALYTICS,
                featuresComparison.PRODUCT_TRAINING,
            ],
        },
    },
    [US_LOCALE]: {
        [PACKAGE_COMPARISON_PAGE]: {
            showMaxFee: true,
            paymentProcessingFeature:
                featuresComparison.PAYMENT_PROCESSING_US_UK_CA_AU,
            sections: {
                0: {
                    features:
                        featuresComparison.START_SELLING_WITH_LANDING_PAGES,
                },
                1: {
                    features: [
                        featuresComparison.MOBILE_OPTIMIZED_PURCHASE_FLOW,
                        featuresComparison.PUBLIC_LISTINGS,
                        featuresComparison.INDUSTRY_LEADING_SEARCH,
                        featuresComparison.AUTOMATED_SOCIAL_NOTIFICATIONS,
                        featuresComparison.ATTENDEE_SHARING_TOOLS,
                        featuresComparison.ABANDONED_ORDER_EMAILS,
                        featuresComparison.PARTNER_DISTRIBUTION_US,
                        featuresComparison.TICKETS_ON_FACEBOOK_US,
                        featuresComparison.EMAIL_INVITATIONS,
                        featuresComparison.DISCOUNT_AND_ACCESS_CODES,
                        featuresComparison.MARKETING_INTEGRATIONS,
                        featuresComparison.SELL_ON_YOUR_WEBSITE,
                        featuresComparison.BRANDED_IMG_ON_TICKETS,
                        featuresComparison.INSTALLMENT_PAYMENTS,
                        featuresComparison.COMMUNITY_PAGES_LANDING_PAGE,
                        featuresComparison.RFID_ENABLED_LANDING_PAGE,
                    ],
                },
                3: {
                    features: [
                        featuresComparison.TICKET_SCANNING_VIA_APP,
                        featuresComparison.ATTENDEE_CHECK_IN_VIA_APP,
                        featuresComparison.OPEN_API,
                        featuresComparison.BADGE_PRINTING_INTEGRATIONS,
                        featuresComparison.SESSION_MANAGEMENT_INTEGRATIONS,
                        featuresComparison.ON_SITE_APP_INTEGRATIONS,
                        featuresComparison.ON_SITE_CONSULTATION_LANDING_PAGE,
                        featuresComparison.ON_SITE_STAFFING_LANDING_PAGE,
                        featuresComparison.RENTAL_EQUIPMENT_LANDING_PAGE,
                        featuresComparison.TEAM_ACCESS_AND_PERMISSIONS,
                        featuresComparison.RFID_ACCESS_MANAGEMENT_LANDING_PAGE,
                        featuresComparison.CASHLESS_PAYMENTS_LANDING_PAGE,
                        featuresComparison.EVENTBRITE_VENUE,
                    ],
                },
            },
        },
        [PACKAGE_THREE_PAGE]: {
            featuresExpansion: {
                features: [
                    features.INCLUDE_PROFESSIONAL,
                    features.RENT_EQUIPMENT,
                    features.PHONE_24_7_SUPPORT,
                    features.INSTALLMENT_PAYMENTS,
                    features.TEAM_PERMISSIONS_B,
                    features.WHITE_LABELING_B,
                    features.TRAINING_AND_SUPPORT_B,
                ],
            },
        },
        [PACKAGE_SELECTION_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: features.PACKAGE_TWO_FEATURES_ALL,
                    },
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.RENTAL_EQUIPMENT,
                            features.BRAND_PAGES,
                            features.INSTALLMENT,
                            features.PRODUCT_TRAINING,
                            features.PHONE_SUPPORT,
                        ],
                        priceDescription: lazyGettext(
                            'Minimum threshold applies',
                        ),
                    },
                },
            },
        },
        [PRICING_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_THREE]: {
                        features: [
                            features.EVERYTHING_IN_PROFESSIONAL,
                            features.TEAM_ACCESS,
                            features.RENTAL_EQUIPMENT,
                            features.BRAND_PAGES,
                            features.INSTALLMENT,
                            features.PRODUCT_TRAINING,
                            features.PHONE_SUPPORT,
                        ],
                        priceDescription: lazyGettext(
                            'Minimum threshold applies',
                        ),
                    },
                },
            },
            grid: {
                showFinePrint: true,
                finePrint: FINE_PRINT_WITH_FIXED_FEE,
                pricePerPaidTicket: appendFinePrintSignifier(
                    PRICE_PER_PAID_TICKET,
                ),
                packagesList: {
                    packages: {
                        [PACKAGE_TWO]: {
                            features: signupFeatures.PACKAGE_TWO_FEATURES_A_US,
                        },
                    },
                },
                extraMainFeatures: [
                    signupFeatures.CUSTOMER_SUPPORT_WITH_PHONE,
                    signupFeatures.TICKET_TYPES,
                    signupFeatures.TR_ESSENTIALS,
                    signupFeatures.LISTING_PARTNER_SITES,
                    signupFeatures.TICKET_SALES_SITE,
                    signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                    signupFeatures.DETAIL_SALES_ANALYTICS,
                    // signupFeatures.PAYOUTS_BEFORE_EVENT,TEMP REMOVING THIS FOR COVID-19
                    signupFeatures.ONSITE_RENTAL_SUPPORT,
                    signupFeatures.BRANDED_PAGES,
                    featuresComparison.PRODUCT_TRAINING,
                ],
            },
        },
        [SIGNUP_PAGE]: {
            packagesList: {
                packages: {
                    [PACKAGE_TWO]: {
                        features: signupFeatures.PACKAGE_TWO_FEATURES_A_US,
                    },
                },
            },
            extraMainFeatures: [
                signupFeatures.CUSTOMER_SUPPORT,
                signupFeatures.TICKET_TYPES,
                signupFeatures.TR_ESSENTIALS,
                signupFeatures.LISTING_PARTNER_SITES,
                signupFeatures.TICKET_SALES_SITE,
                signupFeatures.CUSTOMIZABLE_CHECKOUT_FORMS,
                signupFeatures.DETAIL_SALES_ANALYTICS,
                // signupFeatures.PAYOUTS_BEFORE_EVENT,TEMP REMOVING THIS FOR COVID-19
                signupFeatures.ONSITE_RENTAL_SUPPORT,
                signupFeatures.BRANDED_PAGES,
                featuresComparison.PRODUCT_TRAINING,
            ],
        },
    },
};
